import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import Entries from '../components/enter/entries';
import { LoginInner } from './login';

import '../components/enter/entries_style.scss';

export const EntriesPage = ({
    entry,
    drawTicket,
    user,
    notification,
    game,
    actions,
}) => {
    const { loggedIn } = user;

    if (!loggedIn) {
        return (
            <Layout user={user} notification={notification} actions={actions}>
                <SEO title="Log In" />
                <LoginInner user={user} actions={actions} />
            </Layout>
        );
    } else {
        return (
            <Layout user={user} notification={notification} actions={actions}>
                <SEO title="My Entries" />
                <div className="entries">
                    <div className="upper-content">
                        <h1 className="text-center">My Entries</h1>
                    </div>
                    <div className="lower-content">
                        <div className="inner-area">
                            <Entries entry={entry} actions={actions} />
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EntriesPage);
